import { Button, Col, Form, Modal, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/app.hooks';
import { getCSVExcelColumns } from '../../../../store/bulkImportV2/bulkImportV2.action';
import { bulkImportV2Selector } from '../../../../store/bulkImportV2/bulkImportV2.reducer';
import { globalSearchSelector } from '../../../../store/globalSearch/globalSearch.reducer';
import { ICheckDelimeterProps } from './checkDelimiter.model';

const { Option } = Select;

const CkeckDelimiterModal: React.FC<ICheckDelimeterProps> = (props) => {
  const globalLookups = useAppSelector(globalSearchSelector);
  const bulkImportV2 = useAppSelector(bulkImportV2Selector);
  const dispatch = useAppDispatch();
  const [files, setFiles] = useState([]);
  const { showModal, handleModalClose, setDefaultDelimeter, isUpdateComponent } = props;

  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    const arr: Array<{ original_filename: any; filename: any; delimiter: string }> = [];
    Object.keys(values).map((data) => {
      const fltrObj = files.filter((dataDM) => dataDM.original_filename == data)[0];
      const Obj = {
        filename: fltrObj.original_filename,
        original_filename: fltrObj.filename,
        file_path: fltrObj.file_path,
        delimiter: values[data],
      };
      arr.push(Obj);
    });
    setDefaultDelimeter(arr);
    const global_dd = {
      tenant_id: globalLookups.search.tenant_id ? globalLookups.search.tenant_id : null,
      company_id: globalLookups.search.company_id ? globalLookups.search.company_id : null,
      bu_id: globalLookups.search.bu_id ? globalLookups.search.bu_id : null,
    };
    const valueFinal = { csv_file_info: arr, global_dd };

    dispatch(getCSVExcelColumns(valueFinal));
    handleModalClose();
  };

  useEffect(() => {
    if (
      bulkImportV2?.getExcelColumnsV2?.csvFiles?.length > 0 &&
      bulkImportV2.getExcelColumnsV2.csvFiles !== null
    ) {
      setFiles(bulkImportV2.getExcelColumnsV2.csvFiles);
    }
    else if (
      bulkImportV2?.getExcelColumnsLarge?.csvFiles?.length > 0 &&
      bulkImportV2.getExcelColumnsLarge.csvFiles !== null
    ) {
      setFiles(bulkImportV2.getExcelColumnsLarge.csvFiles);
    }
    if (
      bulkImportV2.getCSVExcelColumns.csvFiles !== null &&
      bulkImportV2.getCSVExcelColumns.csvFiles?.length > 0 &&
      !isUpdateComponent
    ) {
      setFiles(bulkImportV2.getCSVExcelColumns.csvFiles);
    } else if (bulkImportV2.getCSVExcelColumnsforUpdate.csvFiles !== null &&
      bulkImportV2.getCSVExcelColumnsforUpdate.csvFiles?.length > 0
    ) {
      setFiles(bulkImportV2.getCSVExcelColumnsforUpdate.csvFiles);
    }
  }, [bulkImportV2.getExcelColumnsV2.data, bulkImportV2.getCSVExcelColumns.csvFiles, bulkImportV2.getCSVExcelColumnsforUpdate.csvFiles]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={'Select Delimiter'}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        <Form form={form} name="CkeckDelimiter" onFinish={onFinish}>
          <Row gutter={[30, 15]} className="form-label-hide">
            {files &&
              files.map((data, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                  <div className="form-group m-0">
                    <label className="label">{data.original_filename}</label>
                    <Form.Item
                      name={data.original_filename}
                      label={data.original_filename}
                      className="m-0"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Select a Delimiter"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        <Option value=";">Semi Colon(;)</Option>
                        <Option value=",">Comma(,)</Option>
                        <Option value='$T'>TAB(    )</Option>
                        <Option value='#T'>TAB( UCS-2 Encoding )</Option>
                      </Select>
                    </Form.Item>
                  </div>
                </Col>
              ))}
          </Row>
          <div className="btns-block modal-footer">
            <Button key="submit" type="primary" htmlType="submit">
              Check Delimiter
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default CkeckDelimiterModal;
